// TODO: remove deprecated sections after backend updates

export enum PageSections {
  CasesSection = 'cases.case-component',
  ReviewsSection = 'shared.review-component',
  TechStackSectionDeprecated = 'shared.tech-stack-component',
  TechStackSection = 'shared.tech_stacks',
  ClientsSection = 'shared.partners-component',
  HowWeWorkSection = 'industries.steps',
  ConsultationSection = 'homepage.consultation',
  AboutSection = 'homepage.sapients',
  ServicesSectionDeprecated = 'subservice.service-component',
  ServicesSection = 'subservice.service_c',
  MicroserviceSection = 'subservice.sub-service-component',
  TeamSection = 'team.team-block',
  ChallengesSection = 'shared.challenges-component',
  DevelopmentComponentsSection = 'shared.project-ui-component',
  SolutionsSection = 'shared.solutions-component',
  StatsSection = 'shared.achievement-cards-component',
  DetailsSection = 'shared.details-component',
  ProjectDetailsSection = 'shared.project-details-component',
  LeadershipSection = 'team.leadership-team',
  PeopleGrowthSection = 'company.people-growth-component',
  CompanyMissionSection = 'company.prosperity-component',
  CompanyTeamSection = 'team.meet-our-team',
  CompanyPhilosophySection = 'company.philosophy',
  DynamicCasesSection = 'shared.case-service-component',
  CaseFeatureSection = 'detailed-cases.case-feature',
  CaseScreenBlock = 'detailed-cases.contentoo-default-block',
  CaseDeliveredValues = 'contentoo-case.delievered-values',
  InfoSection = 'shared.zig-zag-component',
  TeamSliderSection = 'team.animated-team',
  BenefitsSection = 'shared.horizontal-accordion-component',
  CirclesSlider = 'shared.circles-slider',
  ServicePosts = 'blog.specific-posts-list',
  SocialCardsSection = 'shared.social-cards-list',
  RevealingServicesSection = 'subservice.revealing-sub-services',
  StatisticSection = 'shared.statistic-tiles',
  RevealingPointsSection = 'shared.revealing-points-component',
  NumberedListSection = 'shared.numbered-list',
  ExpandedRevealingPoints = 'shared.expanded-revealing-points',
  VideoCardSliderSection = 'shared.slider-with-video',
  CtaReviewSections = 'shared.cta-review',
  ServiceTilesSection = 'shared.service-tiles-component',
  IndustryTilesSection = 'shared.industry-tiles-component',
  ReviewsListSection = 'review.review-list-component',
  FeaturesSection = 'landing.landing-features',
  ShortCTASection = 'shared.cta-component',
  CTASection = 'shared.cta',
  VideoTourSection = 'landing.see-in-action',
  SimpleTextVideoSection = 'shared.util-title-simple-text-video',
  IntegrationRoadmapSection = 'landing.landing-roadmap',
  PriceListSection = 'landing.landing-setup-and-cost',
  StoresSection = 'shared.landing-services',
  CasesRevealingSection = 'shared.cases-revealing',
  TitleDescriptionSection = 'shared.title-description-component',
  // TODO: this component is deprecated, please remove it
  RevealingCasesHeaderSection = 'shared.revealing-cases-header',
  VideoSection = 'shared.video',
  YoutubeVideoSection = 'shared.util-youtube-video',
  AuthorQuoteSection = 'shared.cta-with-custom-author-quote',
  RichTextSection = 'shared.rich-text',
  CaseSliderSection = 'cases.cases-page-slider',
  CaseRevealingPointsSection = 'cases.cases-revealing-block',
  CustomTeamSection = 'team.custom-team',
  CalculatorCTA = 'cta.calculator-cta',
  HomePageHero = 'homepage.hero',
  AltHomePageHero = 'homepage.hero-roadmap-form',
  HomePageServices = 'homepage.service-offering',
  HomePageSlider = 'homepage.slider',
  HomePageTeamGrid = 'homepage.team-grid',
  BlogArticlesSection = 'blog.blog-articles-block',
  SurveySection = 'roadmap-form.roadmap-form',
  EntitiesSection = 'homepage.roadmap-cases-block',
  ServiceSLiderSection = 'shared.services-subservices-slider',
}
